export default "__VITE_ASSET__BONsCL_j__"